import { render } from "./AddGlossary.vue?vue&type=template&id=afc0cad6"
import script from "./AddGlossary.vue?vue&type=script&lang=js"
export * from "./AddGlossary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__